import { APICore } from "./apiCore";

const api = new APICore();

function fetchProjects(params: { page: string, limit: string, sortBy: string, sort: string, filterBy?: any, searchBy?: string }) {
    const baseUrl = `/project?page=${params.page}&limit=${params.limit}&sortBy=${params.sortBy}&sort=${params.sort}&filterBy=${params.filterBy}&searchBy=${params.searchBy ? params.searchBy : ''}`
    return api.get(`${baseUrl}`, "");
}

function fetchProjectWithValue(params: { filterBy?: any, filter?: any }) {
    const baseUrl = `/project/all/value?filterBy=${params.filterBy}&filter=${params.filter}`;
    return api.get(`${baseUrl}`, "")
}

function fetchProjectWithOngoing(params: { filterBy?: any, filter?: any }) {
    const baseUrl = `/project/ongoing/value?filterBy=${params.filterBy}&filter=${params.filter}`;
    return api.get(`${baseUrl}`, "")
}

function fetchProjectWithCompleted(params: { filterBy?: any, filter?: any }) {
    const baseUrl = `/project/completed/value?filterBy=${params.filterBy}&filter=${params.filter}`;
    return api.get(`${baseUrl}`, "")
}

function fetchFunnelData(params: { filterBy?: any, filter?: any }) {
    const baseUrl = `/project/funnel/data?filterBy=${params.filterBy}&filter=${params.filter}`;
    return api.get(`${baseUrl}`, "")
}


function fetchProjectStatus(params: any) {
    let baseUrl = `/application/metadata?`
    if (params.data.id) {
        baseUrl = baseUrl + 'id=' + params.data.id;
    } else {
        baseUrl = baseUrl + 'title=' + params.data.title;
    }
    return api.get(`${baseUrl}`, "");
}


function getAssignedTask(params: { id: string, page: string, limit: string, sortBy: string, sort: string, filterBy?: any, userId?: any, filter?: any, searchBy?: string }) {
    const baseUrl = `/project/assigned-task/${params.id}?page=${params.page}&limit=${params.limit}&sortBy=${params.sortBy}&sort=${params.sort}&filterBy=${params.filterBy}&userId=${params.userId}&filter=${params.filter}&searchBy=${params.searchBy ? params.searchBy : ''}`
    return api.get(`${baseUrl}`, "")
}

function fetchCountAssignedTasks(params: { user_id: number, status: number }) {
    const baseUrl = `/project/assigned-task/count?user_id=${params.user_id}&status=${params.status}`;
    return api.get(`${baseUrl}`, "");
}

function createProject(data: any) {
    const baseUrl = `/project`;
    return api.create(`${baseUrl}`, { project: data.project });
}

function updateProject(data: any) {
    const baseUrl = `/project/${data.id}`
    return api.update(`${baseUrl}`, { project: data.project })
}


function getProjectTasks(params: { id: string, page: string, limit: string, sortBy: string, sort: string }) {
    const baseUrl = `/project/${params.id}/task?page=${params.page}&limit=${params.limit}&sortBy=${params.sortBy}&sort=${params.sort}`;
    return api.get(`${baseUrl}`, "");
}

function createProjectTask(data: any) {
    console.log("data in create projeet", data)
    const baseUrl = `/project/${data.projectID}/task`;
    return api.create(`${baseUrl}`, { task: data.task })
}

function updateProjectTask(data: any) {
    // console.log("Data in update project task", data)
    const baseUrl = `/project/${data.projectID}/task/${data.taskID}`
    // console.log(baseUrl)
    return api.update(`${baseUrl}`, { task: data.task })
}

function getSingleTask(data: any) {
    const baseUrl = `project/${data.projectID}/task/${data.taskID}`
    return api.get(`${baseUrl}`, {})
}

function getProjectById(id: any) {
    const baseUrl = `/project/${id}`;
    return api.get(`${baseUrl}`, {});
}


function getProjectByUserId(params: { id: string, page: string, limit: string, sortBy: string, sort: string }) {
    const baseUrl = `/project/${params.id}/myproject?page=${params.page}&limit=${params.limit}&sortBy=${params.sortBy}&sort=${params.sort}`;
    return api.get(`${baseUrl}`, "");
}

function getTaskCountBasedOnUser(params: { user: any, filterBy?: any, filter?: any }) {
    const baseUrl = `/project/taskbased/count?user=${params.user}&filterBy=${params.filterBy}&filter=${params.filter}`
    return api.get(`${baseUrl}`, "");
}

function projectMonthData(params: { filterBy?: any, filter?: any }) {
    const baseUrl = `/project/month/data?filterBy=${params.filterBy}&filter=${params.filter}`;
    return api.get(`${baseUrl}`, "")
}


export {
    fetchProjects, createProject, getProjectTasks, createProjectTask,
    updateProjectTask, getProjectById, getSingleTask, getAssignedTask,
    getProjectByUserId, fetchCountAssignedTasks, updateProject, fetchProjectStatus,
    getTaskCountBasedOnUser, projectMonthData, fetchProjectWithValue, fetchProjectWithOngoing, fetchProjectWithCompleted,
    fetchFunnelData
}
